import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeSelect", "optionsSection", "optionsList", "optionRow",
                     "sliderSettings", "ratingSettings", "textSettings", "imageUrlField"]

  connect() {
    this.updateVisibility()
  }

  typeChanged() {
    this.updateVisibility()
  }

  updateVisibility() {
    const type = this.typeSelectTarget.value

    const hasOptions = type === "multiple_choice" || type === "image_choice"
    this.toggle(this.optionsSectionTarget, hasOptions)
    this.toggle(this.sliderSettingsTarget, type === "range_slider")
    this.toggle(this.ratingSettingsTarget, type === "rating")
    this.toggle(this.textSettingsTarget, type === "free_text")

    this.imageUrlFieldTargets.forEach(f => {
      f.closest(".flex")?.style.setProperty("display",
        type === "image_choice" ? "" : "none")
    })
  }

  addOption() {
    const rows = this.optionRowTargets
    const idx = rows.length + 1
    const html = `
      <div class="flex items-center gap-3 mb-3" data-survey-question-form-target="optionRow">
        <span class="text-gray-400 text-sm w-6">${idx}.</span>
        <input type="text" name="options[][label]" value=""
               class="flex-grow rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
               placeholder="Option label">
        <input type="text" name="options[][value]" value=""
               class="w-32 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
               placeholder="Value">
        <input type="text" name="options[][image_url]" value=""
               class="w-48 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
               placeholder="Image URL (optional)"
               data-survey-question-form-target="imageUrlField">
        <button type="button" class="text-red-400 hover:text-red-600"
                data-action="click->survey-question-form#removeOption">
          <i class="fas fa-times"></i>
        </button>
      </div>`

    this.optionsListTarget.insertAdjacentHTML("beforeend", html)
    this.updateVisibility()
  }

  removeOption(event) {
    const row = event.currentTarget.closest("[data-survey-question-form-target='optionRow']")
    if (this.optionRowTargets.length > 2) {
      row.remove()
      this.renumberOptions()
    }
  }

  renumberOptions() {
    this.optionRowTargets.forEach((row, idx) => {
      const num = row.querySelector("span")
      if (num) num.textContent = `${idx + 1}.`
    })
  }

  toggle(el, show) {
    if (el) el.style.display = show ? "" : "none"
  }
}
